"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var utilities_1 = require("@fluentui/utilities");
var DatePicker_base_1 = require("./DatePicker.base");
var DatePicker_styles_1 = require("./DatePicker.styles");
exports.DatePicker = (0, utilities_1.styled)(DatePicker_base_1.DatePickerBase, DatePicker_styles_1.styles, undefined, {
    scope: 'DatePicker',
});
//# sourceMappingURL=DatePicker.js.map